/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { observer } from 'mobx-react-lite';
import { Menu, X_AXIS, Y_AXIS, Popover } from '@veeam/components';

import { MenuItems } from '../MenuItems';
import { useContextMenuStore } from '../../store';

import type { ContextMenuProps } from '../../interfaces';

export const ContextMenu = observer(({ offsetPosition }: ContextMenuProps) => {
    const menuStore = useContextMenuStore();

    if (!menuStore.menuActive) {
        return null;
    }

    return (
        <Popover
            target={{
                measure: () => ({ top: offsetPosition.y, left: offsetPosition.x, width: 0, height: 0 }),
            }}
            config={[
                {
                    xAxis: X_AXIS.insideLeft,
                    yAxis: Y_AXIS.insideTop,
                },
                {
                    xAxis: X_AXIS.insideLeft,
                    yAxis: Y_AXIS.insideBottom,
                },
                {
                    xAxis: X_AXIS.insideRight,
                    yAxis: Y_AXIS.insideTop,
                },
                {
                    xAxis: X_AXIS.insideRight,
                    yAxis: Y_AXIS.insideBottom,
                },
            ]}
            isActive={menuStore.menuActive}
            onOutsideClick={menuStore.hideMenu}
            render={popoverRef => (
                <Menu ref={popoverRef}>
                    <MenuItems />
                </Menu>
            )}
        />
    );
});
